exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__text-area-input___2KNME,.index-module__text-input___XX4-e{margin-bottom:1em;width:100%}.index-module__text-area-input___2KNME{min-height:130px}.index-module__options___CD_m- .index-module__wrapper___2bjKC{display:grid;gap:.5em}.index-module__options___CD_m- .index-module__wrapper___2bjKC .index-module__option___2o58y{display:grid;align-items:center;gap:1em;cursor:pointer;grid-template-columns:auto 1fr}.index-module__options___CD_m- .index-module__wrapper___2bjKC .index-module__option___2o58y p{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);

// exports
exports.locals = {
	"text-area-input": "index-module__text-area-input___2KNME",
	"text-input": "index-module__text-input___XX4-e",
	"options": "index-module__options___CD_m-",
	"wrapper": "index-module__wrapper___2bjKC",
	"option": "index-module__option___2o58y"
};